module.exports = __webpack_public_path__ + "img/confirm_btn.1b173861.png";